<template lang="pug">
div
  .my-4
    .text-sm.font-medium.mb-1 1. {{ $t('diagnosis') }}
    template(v-if="getDiagnosis.length > 0")
      ul.neutral500--text
        li.text-xs.font-normal(v-for="diagnose in getDiagnosis" :key="diagnose") {{ diagnose }}
  .my-4
    .text-sm.font-medium.mb-1 2. {{ $t('case_notes') }}
    template(v-if="getNote")
      .neutral500--text.text-xs.font-normal
        span(v-html="gethtml(getNote)")
  .my-4  
    .text-sm.font-medium.mb-1 3. {{ $t('medication') }}
    template(v-if="getMedications.length > 0")
      ul.neutral500--text
        li.text-xs.font-normal(v-for="(medication, medicationIndex) in getMedications" :key="`medication-${medicationIndex}`") {{ medication.name }}
  .my-4  
    .text-sm.font-medium.mb-1 4. {{ $t('services_and_treatments') }}
    template(v-if="getServices.length > 0")
      ul.neutral500--text
        li.text-xs.font-normal(v-for="(service, serviceIndex) in getServices" :key="`service-${serviceIndex}`") {{ service.name }}
  .my-4  
    .text-sm.font-medium.mb-1 5. {{ $t('documents') }}
    template(v-if="getDocuments.length > 0")
      ul.neutral500--text
        li.text-xs.font-normal(v-for="(document, documentIndex) in getDocuments" :key="`document-${documentIndex}`") {{ document.name }}
  .d-flex.justify-end.mt-4
    v-btn.button-sm(color="primary" depressed @click="$emit('viewDetails')") {{ $t('view_details') }}
</template>

<script>
export default {
  props: {
    parentHistory: {
      type: Object,
      required: true
    },
  },
  computed: {
    getDiagnosis() {
      return this.parentHistory.consultation?.diagnoses ?? []
    },
    getNote() {
      return this.parentHistory.consultation?.note ?? null
    },
    getMedications() {
      return this.parentHistory?.medications ?? []
    },
    getServices() {
      return this.parentHistory?.services ?? []
    },
    getDocuments() {
      return this.parentHistory?.documents ?? []
    }
  },
  methods: {
    gethtml (note) {
      let text = note.replace(/<img.*?>/g, '')
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
</style>